<template>
  <div class="activity-main-root">
    <div class="custom-nav-block" :class="[scrollTop ? 'nav-scrolling' : 'nav-default']" :style="`padding-top:${barHeight}px`">
      <van-nav-bar class="van-bar" left-arrow @click-left="closeWeb" @click-right="handleToRule">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow02.png" alt="" />
        </template>
        <template #right>
          <img class="right-nav" src="@/assets/packageAssets/common/rules02.png" alt="" />
        </template>
      </van-nav-bar>
    </div>

    <div class="activity-con" :style="{ 'margin-top': `-${barHeight + 46}px` }">
      <div class="activity-head" :style="{ 'padding-top': `${barHeight + 46 + 5}px` }">
        <div class="head-title">
          <MyPLabel class="head-title-txt head-title-txt1" :str="$t('lang.activityA3.k001')" :customClass="{ bean: 'act-eidalfitr-bean' }" />
          <div class="head-title-txt head-title-txt2">{{ $t('lang.activityA3.k002') }}</div>
        </div>

        <div class="deal-line">
          <div class="timer">
            <img src="./images/clock.png" />
            <span class="time-num">
              <span>{{ countdownResult.days }}</span>
              <i>{{ $t('lang.commonM.k297') }}</i>
            </span>
            <span class="stp">:</span>
            <span class="time-num">
              <span>{{ countdownResult.hours }}</span>
              <i>{{ $t('lang.commonM.k364') }}</i>
            </span>
            <span class="stp">:</span>
            <span class="time-num">
              <span>{{ countdownResult.minutes }}</span>
              <i>{{ $t('lang.commonM.k365') }}</i>
            </span>
            <span class="stp">:</span>
            <span class="time-num">
              <span>{{ countdownResult.seconds }}</span>
              <i>{{ $t('lang.commonM.k366') }}</i>
            </span>
          </div>
        </div>
      </div>

      <!-- Earn Points -->
      <div class="main-con">
        <div class="part-block part-block1" style="margin-top: 0">
          <div class="part-head">
            <div>{{ $t('lang.commonM.k208') }}</div>
          </div>
          <div class="part-tips">{{ $t('lang.commonM.k419') }}</div>
          <div v-if="actInfo" class="points-rank">
            <div class="pr-item pr-item1">
              <div>{{ $t('lang.commonM.k221') }}</div>
              <div v-if="actInfo">{{ actInfo.score || 0 }}</div>
              <img class="size1" src="./images/star.png" />
            </div>
            <div class="pr-gap"></div>
            <div class="pr-item pr-item2">
              <div>{{ $t('lang.commonM.k222') }}</div>
              <div v-if="actInfo">{{ actInfo.rank || '--' }}</div>
              <img class="size2" src="./images/cup.png" />
            </div>
          </div>
        </div>

        <!-- 里程碑 -->
        <div class="part-block part-block2">
          <div class="part-head">
            <div>{{ $t('lang.commonM.k215') }}</div>
          </div>
          <div class="part-tips">{{ $t('lang.commonM.k421') }}</div>
          <div v-if="actInfo && actInfo.milestoneStates" class="part-percent">
            <div class="progress-box">
              <!-- 左 -->
              <div>
                <div class="box-top" :style="{ opacity: actInfo.milestoneStates[0].state === 2 ? 0.5 : 1 }">
                  <!-- prettier-ignore -->
                  <div>
                    +{{ actInfo.milestoneStates[0].beans }}<img :src="getMatchImg('beans')">
                  </div>
                </div>
                <img v-if="actInfo.milestoneStates[0].state === 2" class="box" src="./images/box-open.png" />
                <img v-if="actInfo.milestoneStates[0].state === 1" class="box sharking" src="./images/box.png" />
                <img v-if="actInfo.milestoneStates[0].state === 0" class="box" src="./images/box.png" />
              </div>
              <!-- 中 -->
              <div>
                <div class="box-top" :style="{ opacity: actInfo.milestoneStates[1].state === 2 ? 0.5 : 1 }">
                  <!-- prettier-ignore -->
                  <div>
                    +{{ actInfo.milestoneStates[1].beans }}<img :src="getMatchImg('beans')">
                  </div>
                </div>
                <img v-if="actInfo.milestoneStates[1].state === 2" class="box" src="./images/box-open.png" />
                <img v-if="actInfo.milestoneStates[1].state === 1" class="box sharking" src="./images/box.png" />
                <img v-if="actInfo.milestoneStates[1].state === 0" class="box" src="./images/box.png" />
              </div>
              <!-- 右 -->
              <div>
                <div class="box-top" :style="{ opacity: actInfo.milestoneStates[2].state === 2 ? 0.5 : 1 }">
                  <!-- prettier-ignore -->
                  <div>
                    +{{ actInfo.milestoneStates[2].beans }}<img :src="getMatchImg('beans')">
                  </div>
                </div>
                <img v-if="actInfo.milestoneStates[2].state === 2" class="box" src="./images/box-open.png" />
                <img v-if="actInfo.milestoneStates[2].state === 1" class="box sharking" src="./images/box.png" />
                <img v-if="actInfo.milestoneStates[2].state === 0" class="box" src="./images/box.png" />
              </div>
            </div>
            <div class="progress-wraper">
              <div class="progress-bar">
                <div class="step step0" :class="{ on: actInfo.milestoneStates[0].state > 0 }"></div>
                <div class="step step1" :class="{ on: actInfo.milestoneStates[1].state > 0 }"></div>
                <div class="step step5" :class="{ on: actInfo.milestoneStates[2].state > 0 }"></div>
                <div class="progress-trace" :style="{ width: mePosition1 }">
                  <div v-if="mePosition1 !== '100%'" class="me"></div>
                </div>
              </div>
            </div>
            <div class="progress-points">
              <div class="points-name">{{ $t('lang.valRuFe.points') }}:</div>
              <div class="points-num">
                <div>{{ actInfo.milestoneStates[0].points }}</div>
                <div>{{ actInfo.milestoneStates[1].points }}</div>
                <div>{{ actInfo.milestoneStates[2].points }}</div>
              </div>
            </div>
            <div style="width: 100%; height: 20px"></div>
            <div class="progress-box">
              <!-- 左 -->
              <div>
                <div class="box-top" :style="{ opacity: actInfo.milestoneStates[3].state === 2 ? 0.5 : 1 }">
                  <!-- prettier-ignore -->
                  <div>
                    +{{ actInfo.milestoneStates[3].beans }}<img :src="getMatchImg('beans')">
                  </div>
                </div>
                <img v-if="actInfo.milestoneStates[3].state === 2" class="box" src="./images/box-open.png" />
                <img v-if="actInfo.milestoneStates[3].state === 1" class="box sharking" src="./images/box.png" />
                <img v-if="actInfo.milestoneStates[3].state === 0" class="box" src="./images/box.png" />
              </div>
              <!-- 中 -->
              <div>
                <div class="box-top" :style="{ opacity: actInfo.milestoneStates[4].state === 2 ? 0.5 : 1 }">
                  <!-- prettier-ignore -->
                  <div>
                    +{{ actInfo.milestoneStates[4].beans }}<img :src="getMatchImg('beans')">
                  </div>
                </div>
                <img v-if="actInfo.milestoneStates[4].state === 2" class="box" src="./images/box-open.png" />
                <img v-if="actInfo.milestoneStates[4].state === 1" class="box sharking" src="./images/box.png" />
                <img v-if="actInfo.milestoneStates[4].state === 0" class="box" src="./images/box.png" />
              </div>
              <!-- 右 -->
              <div>
                <div class="box-top" :style="{ opacity: actInfo.milestoneStates[5].state === 2 ? 0.5 : 1 }">
                  <!-- prettier-ignore -->
                  <div>
                    +{{ actInfo.milestoneStates[5].beans }}<img :src="getMatchImg('beans')">
                  </div>
                </div>
                <img v-if="actInfo.milestoneStates[5].state === 2" class="box" src="./images/box-open.png" />
                <img v-if="actInfo.milestoneStates[5].state === 1" class="box sharking" src="./images/box.png" />
                <img v-if="actInfo.milestoneStates[5].state === 0" class="box" src="./images/box.png" />
              </div>
            </div>
            <div class="progress-wraper">
              <div class="progress-bar">
                <div class="step step0" :class="{ on: actInfo.milestoneStates[3].state > 0 }"></div>
                <div class="step step1" :class="{ on: actInfo.milestoneStates[4].state > 0 }"></div>
                <div class="step step5" :class="{ on: actInfo.milestoneStates[5].state > 0 }"></div>
                <div class="progress-trace" :style="{ width: mePosition2 }">
                  <div v-if="mePosition2 !== '0%'" class="me"></div>
                </div>
              </div>
            </div>
            <div class="progress-points">
              <div class="points-name"></div>
              <div class="points-num">
                <div>{{ actInfo.milestoneStates[3].points }}</div>
                <div>{{ actInfo.milestoneStates[4].points }}</div>
                <div>{{ actInfo.milestoneStates[5].points }}</div>
              </div>
            </div>
          </div>

          <div class="btn-default">
            <div v-if="canClaim == 'canClaim'" class="real-btn" @click="handleClaim()">{{ $t('lang.commonM.k073') }}</div>
            <div v-if="canClaim == 'canNotClaim'" class="real-btn btn-disable">{{ $t('lang.commonM.k073') }}</div>
            <div v-if="canClaim == 'claimed'" class="real-btn btn-disable">{{ $t('lang.commonM.k074') }}</div>
          </div>
        </div>

        <!-- 排行榜 -->
        <div class="part-block part-block3">
          <div class="part-head">
            <div>{{ $t('lang.activityA3.k003') }}</div>
            <div>{{ $t('lang.activityA3.k004') }}</div>
          </div>
          <div class="part-rewards">
            <div class="rewards-block">
              <div class="reward-block-head">
                <div class="reward-mark"></div>
                <span>{{ $t('lang.activityA3.k005') }}&nbsp;</span>
                <span>{{ countdownResult.days }}{{ $t('lang.commonM.k297') }}&nbsp;</span>
                <span>{{ countdownResult.hours }}</span>
                <span>:</span>
                <span>{{ countdownResult.minutes }}</span>
                <span>:</span>
                <span>{{ countdownResult.seconds }}</span>
              </div>
              <div class="reward-block-con">
                <div class="reward-item">
                  <div class="reward-1st">{{ $t('lang.activityA3.k006') }}</div>
                  <div>
                    <img :src="getMatchImg('beans')" />
                    <span>{{ boardData.num1Reward }}</span>
                  </div>
                </div>
                <div class="reward-gap"></div>
                <div class="reward-item">
                  <div class="reward-2nd">{{ $t('lang.activityA3.k007') }}</div>
                  <div>
                    <img :src="getMatchImg('beans')" />
                    <span>{{ boardData.num2Reward }}</span>
                  </div>
                </div>
                <div class="reward-gap"></div>
                <div class="reward-item">
                  <div class="reward-3rd">{{ $t('lang.activityA3.k008') }}</div>
                  <div>
                    <img :src="getMatchImg('beans')" />
                    <span>{{ boardData.num3Reward }}</span>
                  </div>
                </div>
                <div class="reward-gap"></div>
                <div class="reward-item">
                  <div class="reward-4th">4-10</div>
                  <div>
                    <img :src="getMatchImg('beans')" />
                    <span>{{ boardData.num4Reward }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="part-rank">
            <!-- 1-3 -->
            <div class="prize">
              <div class="two">
                <img class="rank_c2_avatar" :src="prize2.avatar | imgPath" alt="" />
                <div class="rank-sort">
                  <img src="./images/r-two.png" />
                </div>
                <div class="item-num">
                  <span class="name">{{ prize2.nickname || '--' }}</span>
                  <span class="num">
                    {{ prize2.score || '--' }}
                    {{ $t('lang.commonM.k260') }}
                  </span>
                </div>
                <div class="rank-line"></div>
              </div>

              <div class="prize-gap"></div>

              <div class="one">
                <img class="crown" src="./images/crown.png" />
                <img class="rank_c1_avatar" :src="prize1.avatar | imgPath" alt="" />
                <div class="rank-sort">
                  <img src="./images/r-one.png" />
                </div>
                <div class="item-num">
                  <span class="name">{{ prize1.nickname || '--' }}</span>
                  <span class="num">
                    {{ prize1.score || '--' }}
                    {{ $t('lang.commonM.k260') }}
                  </span>
                </div>
                <div class="rank-line"></div>
              </div>

              <div class="prize-gap"></div>

              <div class="three">
                <img class="rank_c3_avatar" :src="prize3.avatar | imgPath" alt="" />
                <div class="rank-sort">
                  <img src="./images/r-three.png" />
                </div>
                <div class="item-num">
                  <span class="name">{{ prize3.nickname || '--' }}</span>
                  <span class="num">
                    {{ prize3.score || '--' }}
                    {{ $t('lang.commonM.k260') }}
                  </span>
                </div>
                <div class="rank-line"></div>
              </div>
            </div>
          </div>

          <div class="btn-green">
            <div class="real-btn" @click="handleToRank">
              {{ $t('lang.activityA3.k010') }}
              <img src="./images/arrow.png" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 奖励弹窗 -->
    <div v-if="showReward" class="mask">
      <div class="dia-con">
        <div class="dia-tit">
          <span>{{ $t('lang.commonM.k147') }}!</span>
        </div>

        <div class="reward-item">
          <span>+{{ reward }}</span>
          <img :src="getMatchImg('beans')" alt="" />
        </div>

        <div class="dia-btn" @click="showReward = false">{{ $t('lang.ok') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { normalActBaseInfo, normalActRank, normalMilesClaim } from './apidir/api.js'

import countDown from '@/mixin/count-down.js'
import scrollMixin from '@/mixin/index.js'

export default {
  mixins: [countDown, scrollMixin],
  data() {
    return {
      actInfo: null,
      packageName: '',
      boardData: {
        num1Reward: 0,
        num2Reward: 0,
        num3Reward: 0,
        num4Reward: 0
      },
      canClaim: 'canNotClaim',
      mePosition1: '7%',
      mePosition2: '0%',

      // bar
      prize1: {},
      prize2: {},
      prize3: {},

      // reward
      showReward: false,
      reward: 0,

      // 其他
      loading: false
    }
  },
  methods: {
    handleToRule() {
      this.$router.push({ path: '/eidalfitr-rules-female', query: { from: 'eidalfitr-main-female' } })
    },
    handleToRank() {
      this.$router.push({ path: '/eidalfitr-rank-female', query: { from: 'eidalfitr-main-female' } })
    },
    handleReplaceToRank() {
      this.$router.replace({ path: '/eidalfitr-rank-female' })
    },
    handleClaim() {
      if (this.actInfo.milestoneStates && this.actInfo.milestoneStates.length) {
        if (this.actInfo.milestoneStates.some((item) => item.state === 1)) {
          if (this.loading) {
            return
          }
          this.loading = true

          normalMilesClaim()
            .then((resData) => {
              if (resData && !resData.error) {
                this.showReward = true
                this.reward = resData.data
                this.fetchBaseData()
              }
            })
            .finally(() => {
              this.loading = false
            })
        }
      }
    },
    fetchBaseData() {
      normalActBaseInfo().then((resData) => {
        if (resData && !resData.error) {
          this.actInfo = resData || null

          if (!this.actInfo) return

          if (this.actInfo.countdown <= 0) {
            this.handleReplaceToRank()
            return
          }

          // 初始化倒计时
          if (this.actInfo.endTimestamp) {
            this.initCountDown(resData.endTimestamp, true, true)
          }

          if (this.actInfo.leaderboardRewards && this.actInfo.leaderboardRewards.length) {
            this.boardData.num1Reward = this.actInfo.leaderboardRewards[0] || 0
            this.boardData.num2Reward = this.actInfo.leaderboardRewards[1] || 0
            this.boardData.num3Reward = this.actInfo.leaderboardRewards[2] || 0
            this.boardData.num4Reward = this.actInfo.leaderboardRewards[3] || 0
          }

          if (this.actInfo.milestoneStates && this.actInfo.milestoneStates.length === 6) {
            // 可领取
            let claimStatus = 'canNotClaim'
            if (this.actInfo.milestoneStates.some((item) => item.state === 1)) {
              claimStatus = 'canClaim'
            }
            if (this.actInfo.milestoneStates.every((item) => item.state === 2)) {
              claimStatus = 'claimed'
            }
            this.canClaim = claimStatus

            if (this.actInfo.score < this.actInfo.milestoneStates[0].points) {
              this.mePosition1 = '7%'
              this.mePosition2 = '0%'
            }

            if (this.actInfo.score === this.actInfo.milestoneStates[0].points) {
              this.mePosition1 = '12.6%'
              this.mePosition2 = '0%'
            }

            if (this.actInfo.score > this.actInfo.milestoneStates[0].points && this.actInfo.score < this.actInfo.milestoneStates[1].points) {
              this.mePosition1 = '35%'
              this.mePosition2 = '0%'
            }

            if (this.actInfo.score === this.actInfo.milestoneStates[1].points) {
              this.mePosition1 = '55%'
              this.mePosition2 = '0%'
            }

            if (this.actInfo.score > this.actInfo.milestoneStates[1].points && this.actInfo.score < this.actInfo.milestoneStates[2].points) {
              this.mePosition1 = '75%'
              this.mePosition2 = '0%'
            }

            if (this.actInfo.score == this.actInfo.milestoneStates[2].points) {
              this.mePosition1 = '100%'
              this.mePosition2 = '0%'
            }

            if (this.actInfo.score >= this.actInfo.milestoneStates[2].points && this.actInfo.score < this.actInfo.milestoneStates[3].points) {
              this.mePosition1 = '100%'
              this.mePosition2 = '7%'
            }

            if (this.actInfo.score == this.actInfo.milestoneStates[3].points) {
              this.mePosition1 = '100%'
              this.mePosition2 = '12.6%'
            }

            if (this.actInfo.score > this.actInfo.milestoneStates[3].points && this.actInfo.score < this.actInfo.milestoneStates[4].points) {
              this.mePosition1 = '100%'
              this.mePosition2 = '35%'
            }

            if (this.actInfo.score == this.actInfo.milestoneStates[4].points) {
              this.mePosition1 = '100%'
              this.mePosition2 = '55%'
            }

            if (this.actInfo.score > this.actInfo.milestoneStates[4].points && this.actInfo.score < this.actInfo.milestoneStates[5].points) {
              this.mePosition1 = '100%'
              this.mePosition2 = '75%'
            }

            if (this.actInfo.score >= this.actInfo.milestoneStates[5].points) {
              this.mePosition1 = '100%'
              this.mePosition2 = '100%'
            }
          }
        }
      })

      normalActRank().then((resData) => {
        if (resData && !resData.error) {
          // 排名数据
          if (resData.ranks && resData.ranks.length > 0) {
            // 前三名
            this.prize1 = resData.ranks[0] || {}
            this.prize2 = resData.ranks[1] || {}
            this.prize3 = resData.ranks[2] || {}
          }
        }
      })
    }
  },
  created() {
    this.fetchBaseData()
  }
}
</script>

<style lang="less" scoped>
.activity-main-root {
  width: 100%;
  min-height: 100vh;
  background: #06391f;

  .nav-default {
    background: url(./images/main-bg.png) top left / 100% auto no-repeat;
  }

  .nav-scrolling {
    background: #06391f;
  }

  .activity-con {
    position: relative;
    .activity-head {
      width: 100%;
      min-height: 316px;
      font-size: 0;
      position: relative;
      background: url(./images/main-bg.png) top left / 100% auto no-repeat;
      .head-title {
        width: 100%;
        padding: 0 20px;
        margin: 10px auto 0;

        .head-title-txt {
          color: #fee81e;
          text-align: center;
          text-shadow: 3px 2px 0 #ac4801, 1px 2px 0 #ac4901, 5px 3px 8px rgba(10, 10, 10, 0.73);
          font-family: 'Anton-Regular';
          font-weight: bold;
        }
        .head-title-txt1 {
          text-indent: 36px;
          font-size: 32px;
          line-height: 48px;
        }
        .head-title-txt2 {
          font-size: 28px;
          line-height: 42px;
        }
      }

      .deal-line {
        width: 100%;
        margin: 43px auto 0;
        display: flex;
        align-items: center;
        justify-content: center;

        .timer {
          min-width: 223px;
          height: 40px;
          padding: 0 24px;

          display: inline-flex;
          align-items: center;
          justify-content: center;

          border-radius: 20px;
          border: 1px solid #b47e11;
          background: linear-gradient(90deg, rgba(55, 143, 85, 0.8) 0%, rgba(19, 91, 54, 0.8) 100%);
          backdrop-filter: blur(1px);
          img {
            width: 32px;
            height: 32px;
            margin: 0 3px;
          }
          > span {
            background: linear-gradient(180deg, #fff6a2 0%, #fffcb4 50%, #cbb811 100%);
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            font-family: 'TikTok Sans';
            font-size: 18px;
            font-weight: 600;
            line-height: normal;

            display: flex;
            align-items: flex-end;
            i {
              background: linear-gradient(180deg, #fff6a2 0%, #fffcb4 50%, #cbb811 100%);
              background-clip: text;
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              font-family: 'TikTok Sans';
              font-size: 16px;
              font-weight: 600;
              line-height: normal;
            }
          }
          .stp {
            padding: 0 2px;
          }
          .time-num {
            span {
              width: 24px;
              text-align: center;
            }
          }
        }
      }
    }

    .main-con {
      position: relative;
      overflow: hidden;
      padding-bottom: 79px;
      margin-top: -40px;

      .part-block {
        width: 355px;
        margin: 16px auto 0;
        padding: 5px 0 16px;
        border-radius: 12px;
        .part-head {
          width: 355px;
          line-height: 23px;
          border-radius: 12px 12px 0px 0px;
          text-align: center;
          > div:nth-child(1) {
            color: #ffffff;
            font-family: 'TikTokSans-Regular';
            font-size: 17px;
            font-weight: bold;
          }
          > div:nth-child(2) {
            color: rgba(224, 255, 200, 0.92);
            font-family: 'TikTokSans-Regular';
            font-size: 14px;
            font-weight: 400;
          }
        }

        .part-tips {
          width: 100%;
          padding: 16px;
          font-family: TikTokSans-Regular;
          font-size: 15px;
          color: rgba(224, 255, 200, 0.92);
          line-height: 22px;
          font-weight: normal;
        }

        .points-rank {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 8px;
          .pr-item {
            flex: 1;
            min-height: 66px;
            padding: 16px 16px 20px;
            border-radius: 8px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            position: relative;
            div:nth-child(1) {
              font-family: TikTokSans-Regular;
              font-weight: 400;
              font-size: 14px;
              color: rgba(224, 255, 200, 0.92);
            }
            div:nth-child(2) {
              margin-top: 4px;
              font-family: TikTokSans-Regular;
              font-weight: 700;
              font-size: 32px;
              color: #ffe522;
              line-height: 36px;
              max-width: calc(100% - 34px);
              word-wrap: break-word;
            }
            img {
              position: absolute;
              right: 5px;
              bottom: 0px;
            }
            img.size1 {
              width: 36px;
              height: 36px;
              bottom: 20px;
            }
            img.size2 {
              width: 40px;
              height: 59px;
              bottom: 9px;
            }
          }
          .pr-item1 {
            background: url(./images/item-point.png) top left / 100% 100% no-repeat;
          }
          .pr-item2 {
            background: url(./images/item-rank.png) top left / 100% 100% no-repeat;
          }
          .pr-gap {
            width: 16px;
          }
        }

        .part-percent {
          width: 100%;
          padding: 0 16px 0;
          .progress-box {
            width: 300px;
            margin: 0 auto;
            display: flex;
            align-items: center;
            > div {
              display: flex;
              flex-direction: column;
              .box-top {
                min-width: 52px;
                min-height: 31px;
                padding: 0 5px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                background: url(./images/tip-wrap.png) left top / 100% 100% no-repeat;
                > div {
                  color: #fff;
                  font-family: 'TikTokSans-Regular';
                  font-size: 15px;
                  font-style: normal;
                  font-weight: 700;
                  line-height: 20px;
                  padding-bottom: 5px;
                }
                img {
                  width: 14px;
                  margin: 0 2px;
                }
              }
              .box {
                width: 34px;
              }
              .sharking {
                // animation: shake 1.5s infinite linear;
                // transform-origin: center bottom;
              }
              &:nth-child(1) {
                display: flex;
                align-items: center;
                justify-content: center;
                transform: translateX(20px);
              }
              &:nth-child(2) {
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                transform: translateX(15px);
              }
              &:nth-child(3) {
                display: flex;
                align-items: center;
                justify-content: flex-end;
                transform: translateX(15px);
              }
            }
          }
          .progress-wraper {
            width: 286px;
            height: 20px;
            margin: 5px auto 0;
            display: flex;
            align-items: center;
            .progress-bar {
              width: 100%;
              height: 8px;
              border-radius: 100px;
              background: #fff1c2;
              display: flex;
              align-items: center;
              justify-content: flex-start;
              position: relative;
              overflow: visible;

              .step {
                width: 14px;
                height: 14px;
                border-radius: 12px;
                border-radius: 12px;
                border: 2px solid #fff;
                background: #fff1c2;
                position: absolute;
                top: 50%;
                margin-top: -7px;
                z-index: 9;
                &.on {
                  border: 2px solid #fff;
                  background: #378f55;
                }
              }
              .step0 {
                left: 36px;
              }
              .step1 {
                left: calc(50% + 18px);
                margin-left: -7px;
              }
              .step5 {
                left: 100%;
                margin-left: -7px;
              }

              .progress-trace {
                width: 20px;
                height: 100%;
                border-radius: 100px;
                background: linear-gradient(90deg, #40ad9b 0%, #378f55 73.57%);
                position: relative;
                overflow: visible;
                .me {
                  position: absolute;
                  top: 50%;
                  right: -16px;
                  z-index: 99;
                  margin-top: -10px;
                  width: 31px;
                  height: 20px;
                  background: url(./images/progress-me.png) left top / 100% 100% no-repeat;
                }
              }
            }
          }
          .progress-points {
            width: 100%;
            height: 20px;
            margin: 0 auto;
            display: flex;
            align-items: center;

            .points-name {
              width: 50px;
              color: #ffffff;
              font-family: 'TikTokSans-Regular';
              font-size: 12px;
              font-style: normal;
              font-weight: 600;
              line-height: normal;
            }
            .points-num {
              flex: 1;
              color: #ffffff;
              font-family: 'TikTokSans-Regular';
              font-size: 12px;
              font-style: normal;
              font-weight: 600;
              line-height: normal;

              display: flex;
              align-items: center;
              justify-content: space-between;
              > div {
                &:nth-child(1) {
                  transform: translateX(5px);
                }
                &:nth-child(2) {
                  transform: translateX(-6px);
                }
                &:nth-child(3) {
                  transform: translateX(-11px);
                }
              }
            }
          }
        }

        .part-rewards {
          padding: 0 26px;
          margin-top: 15px;
          .rewards-block {
            display: flex;
            flex-direction: column;
            .reward-block-head {
              display: flex;
              align-items: center;
              padding: 3px 4px;
              border-radius: 12px 12px 0 0;
              background: rgba(0, 0, 0, 0.2);
              backdrop-filter: blur(3px);
              > div {
                width: 16px;
                height: 16px;
                margin: 0 8px;
                background: url(./images/reward-mark.png) top left / 100% 100% no-repeat;
              }
              > span {
                color: rgba(224, 255, 200, 0.92);
                font-family: 'TikTokSans-Regular';
                font-size: 12px;
                font-weight: 400;
              }
            }
            .reward-block-con {
              margin-top: -2px;
              display: flex;
              align-items: center;
              padding: 12px 0;
              border-radius: 0 0 12px 12px;
              background: rgba(0, 0, 0, 0.2);
              backdrop-filter: blur(3px);
              .reward-item {
                flex: 1;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                > div:nth-child(1) {
                  text-align: center;
                  font-family: 'TikTokSans-Regular';
                  font-size: 12px;
                  font-weight: 500;
                }
                > div:nth-child(2) {
                  display: flex;
                  align-items: center;
                  > img {
                    width: 14px;
                    height: 14px;
                    margin: 0 2px;
                  }
                  > span {
                    color: #ffffff;
                    text-align: center;
                    font-family: 'TikTokSans-Regular';
                    font-size: 14px;
                    font-weight: 700;
                  }
                }

                .reward-1st {
                  color: #ffe522;
                }
                .reward-2nd {
                  color: #ecb35d;
                }
                .reward-3rd {
                  color: #fed7aa;
                }
                .reward-4th {
                  color: rgba(255, 255, 255, 0.5);
                }
              }
              .reward-gap {
                width: 5px;
                height: 36px;
                position: relative;
                &::after {
                  content: '';
                  position: absolute;
                  top: 0;
                  left: 50%;
                  width: 1px;
                  height: 100%;
                  background: rgba(255, 255, 255, 0.1);
                }
              }
            }
          }
        }

        .part-rank {
          margin-top: 10px;
          position: relative;
          margin-bottom: 12px;
          .prize {
            width: 100%;
            margin: 0 auto;
            padding: 0 28px;
            display: flex;
            align-items: flex-end;
            justify-content: center;
            .prize-gap {
              width: 11px;
            }
            .one,
            .two,
            .three {
              width: 90px;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: flex-end;

              .item-num {
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                .name {
                  font-family: 'TikTokSans-Regular';
                  color: #ffffff;

                  width: 100%;
                  overflow: hidden;
                  text-align: center;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
                .num {
                  display: flex;
                  align-items: center;
                  font-family: 'Poppins-Regular';
                  font-size: 12px;
                  text-align: center;
                  display: inline-flex;
                  align-items: center;
                }
              }
            }
            .one {
              padding: 0 0 15px;
              .crown {
                width: 36px;
                position: static;
                z-index: 2;
              }
              .rank_c1_avatar {
                width: 56px;
                height: 56px;
                margin-top: -10px;
                border-radius: 50%;
                object-fit: cover;
                border: 2px solid #ffe522;
              }
              .rank-sort {
                display: flex;
                width: 24px;
                margin-top: -10px;
                img {
                  width: 100%;
                }
              }
              .item-num {
                .name {
                  font-size: 16px;
                  font-weight: 700;
                }
                .num {
                  color: #ffd700;
                  font-weight: 700;
                }
              }
              .rank-line {
                width: 100%;
                height: 6px;
                margin-top: 10px;
                border-radius: 9999px;
                background: #ffd700;
                box-shadow: 0 0 10px 0 rgba(255, 215, 0, 0.3);
              }
            }
            .two {
              .rank_c2_avatar {
                width: 48px;
                height: 48px;
                border-radius: 50%;
                object-fit: cover;
                border: 2px solid #b3700c;
              }
              .rank-sort {
                display: flex;
                width: 22px;
                margin-top: -10px;
                img {
                  width: 100%;
                }
              }
              .item-num {
                .name {
                  font-size: 14px;
                  font-weight: 400;
                }
                .num {
                  color: #ecb35d;
                  font-weight: 400;
                }
              }
              .rank-line {
                width: 100%;
                height: 4px;
                margin-top: 7px;
                border-radius: 9999px;
                background: #ecb35d;
              }
            }
            .three {
              .rank_c3_avatar {
                width: 48px;
                height: 48px;
                border-radius: 50%;
                object-fit: cover;
                border: 2px solid #c0a585;
              }
              .rank-sort {
                display: flex;
                width: 22px;
                margin-top: -10px;
                img {
                  width: 100%;
                }
              }
              .item-num {
                .name {
                  font-size: 14px;
                  font-weight: 400;
                }
                .num {
                  color: #fed7aa;
                  font-weight: 400;
                }
              }
              .rank-line {
                width: 100%;
                height: 4px;
                margin-top: 7px;
                border-radius: 9999px;
                background: #fed7aa;
              }
            }
          }
        }
      }

      .part-block1 {
        min-height: 200px;
        background: url(./images/block-bg1.png) top left / 100% 100% no-repeat;
      }

      .part-block2 {
        min-height: 400px;
        background: url(./images/block-bg2.png) top left / 100% 100% no-repeat;
      }

      .part-block3 {
        min-height: 400px;
        background: url(./images/block-bg3.png) top left / 100% 100% no-repeat;
      }

      .task-block {
        padding: 0 16px;
        .part-tips-b {
          font-family: TikTokSans-Regular;
          font-weight: 500;
          font-size: 17px;
          color: #ffffff;
          line-height: 22px;
          margin-top: 32px;
          text-align: left;
        }
        .part-task {
          margin-top: 13px;
          font-family: TikTokSans-Regular;
          font-weight: 400;
          font-size: 15px;
          color: #ffffff;
          line-height: 20px;
          display: flex;
          justify-content: space-between;
        }
      }

      .btn-default {
        display: block;
        width: 100%;
        margin: 30px auto 8px;
        text-align: center;
        .real-btn {
          min-width: 275px;
          display: inline-block;
          padding: 10px 15px;
          border-radius: 12px;
          border: 1px solid #fede86;
          background: linear-gradient(270deg, #feb814 -22.42%, #ffffa8 50.93%, #fac401 115.07%);
          box-shadow: 0 -0.2px 0.5px 0 rgba(81, 43, 0, 0.05);
          font-family: TikTokSans-Regular;
          font-weight: 700;
          font-size: 20px;
          color: #052f19;
          line-height: 26px;
          text-align: center;
          &.btn-disable {
            border-radius: 12px;
            border: 1px solid #c3c2c1;
            background: linear-gradient(270deg, #8a8988 -22.42%, #d4d4d3 50.93%, #7f7e7c 115.07%);
            box-shadow: 0 -0.2px 0.5px 0 rgba(41, 41, 40, 0.05);
            color: #ffffff;
          }
        }
      }

      .btn-green {
        display: block;
        width: 100%;
        margin-top: 26px;
        text-align: center;
        .real-btn {
          width: 303px;
          display: inline-block;
          padding: 14px 5px;
          border-radius: 12px;
          border: 0.5px solid #fede86;
          background: linear-gradient(90deg, #378f55 0%, #3c9a62 50%, #135b36 100%);
          font-family: TikTokSans-Regular;
          font-weight: 700;
          font-size: 14px;
          color: #ffe522;
          line-height: 18px;
          text-align: center;
          img {
            width: 12px;
            vertical-align: middle;
          }
        }
      }
    }
  }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.7);
    overflow-y: auto;

    display: flex;
    align-items: center;
    justify-content: center;

    .dia-con {
      width: 315px;
      padding: 50px 16px 20px;
      border-radius: 16px;
      background: url(./images/dialog-bg2.png) top left/ 100% 100% no-repeat;

      .dia-tit {
        color: #fffbea;
        text-align: center;
        font-family: 'TikTokSans-Regular';
        font-size: 20px;
        font-weight: 800;
      }

      .reward-item {
        margin-top: 26px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 23px;
          margin: 0 4px;
        }

        span {
          font-family: 'TikTokSans-Regular';
          font-weight: bold;
          font-size: 20px;
          color: #ffffff;
          line-height: 28px;
          text-align: center;
        }
      }

      .dia-btn {
        width: 255px;
        line-height: 26px;
        margin: 20px auto 0;
        padding: 10px;
        border-radius: 26px;
        border: 1px solid #fede86;
        background: linear-gradient(270deg, #feb814 -22.42%, #ffffa8 50.93%, #fac401 115.07%);
        box-shadow: 0 -0.2px 0.5px 0 rgba(81, 43, 0, 0.05);
        font-family: 'TikTokSans-Regular';
        font-weight: 600;
        font-size: 20px;
        color: #052f19;
        text-align: center;
      }
    }
  }
}

@keyframes shake {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(-10deg);
  }
  50% {
    transform: rotate(0deg);
  }
  75% {
    transform: rotate(10deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .activity-main-root .activity-con .main-con .part-block .points-rank .pr-item img {
    right: unset;
    left: 5px;
  }

  .activity-main-root {
    .activity-con {
      .main-con {
        .part-block {
          .part-percent {
            .progress-box {
              > div {
                &:nth-child(1) {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  transform: translateX(-20px);
                }
                &:nth-child(2) {
                  flex: 1;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  transform: translateX(-15px);
                }
                &:nth-child(3) {
                  display: flex;
                  align-items: center;
                  justify-content: flex-end;
                  transform: translateX(-15px);
                }
              }
            }
            .progress-wraper {
              .progress-bar {
                .step0 {
                  left: unset;
                  right: 36px;
                }
                .step1 {
                  left: unset;
                  right: calc(50% + 18px);
                  margin-right: -7px;
                }
                .step5 {
                  left: unset;
                  right: 100%;
                  margin-right: -7px;
                }

                .progress-trace {
                  .me {
                    right: unset;
                    left: -16px;
                    transform: rotateY(180deg);
                  }
                }
              }
            }
            .progress-points {
              .points-num {
                > div {
                  &:nth-child(1) {
                    transform: translateX(-5px);
                  }
                  &:nth-child(2) {
                    transform: translateX(6px);
                  }
                  &:nth-child(3) {
                    transform: translateX(11px);
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>

<style>
.act-eidalfitr-bean {
  width: 36px;
  height: 36px;
}
</style>
